import "./fadingScrollbars.css";

// Shows a form's scrollbar while it scrolls and hides it once scrolling stops
// (the fade itself is in fadingScrollbars.css). One capture-phase listener on
// the document covers every dialog and drawer, including ones mounted later:
// scroll events don't bubble, but they do capture.

const SCROLLABLE = ".ant-modal-body, .ant-drawer-body";
// Short enough to vanish promptly, long enough not to flicker between the
// separate events of one wheel or trackpad gesture.
const HIDE_AFTER_MS = 600;

const timers = new WeakMap();

function onScroll(e) {
  const el = e.target;
  if (!(el instanceof Element) || !el.matches(SCROLLABLE)) return;
  el.classList.add("is-scrolling");
  clearTimeout(timers.get(el));
  timers.set(
    el,
    setTimeout(() => el.classList.remove("is-scrolling"), HIDE_AFTER_MS),
  );
}

if (typeof document !== "undefined" && !window.__anFadingScrollbars) {
  window.__anFadingScrollbars = true;
  document.addEventListener("scroll", onScroll, { capture: true, passive: true });
}
